var map = {
	"./bronze.png": 2227,
	"./challenger.png": 9900,
	"./diamond.png": 1123,
	"./gold.png": 7214,
	"./grandmaster.png": 4672,
	"./iron.png": 2568,
	"./master.png": 6629,
	"./platinum.png": 6404,
	"./silver.png": 535
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8500;